<template>
    <v-container fill-height fluid grid-list-xl class="pt-0">
        <v-flex md12>
            <material-card color="green" :title="title" class="grid-card">
                <v-layout row class="mt-0 mr-1">
                    <v-spacer></v-spacer>
                    <v-select
                        v-model="regID"
                        label="Term"
                        class="pl-3 width-250"
                        :items="terms"
                        hide-details
                        @change="onTermChanged"
                    ></v-select>
                    <v-select
                        v-model="program"
                        label="Program"
                        class="pl-3 width-300"
                        :items="programs.map((p) => p.name)"
                        hide-details
                        @change="onProgramChanged"
                    ></v-select>
                </v-layout>

                <vue-good-table
                    class="pt-3"
                    ref="table"
                    :columns="columns"
                    :rows="classSummary"
                    :search-options="{
                        enabled: false,
                    }"
                    :groupOptions="{
                        enabled: !program.startsWith('H-11'),
                        headerPosition: 'bottom',
                    }"
                >
                    <template slot="table-header-row" slot-scope="props">
                        <div>
                            <span>
                                {{ props.formattedRow[props.column.field] }}
                            </span>
                        </div>
                    </template>
                    <template slot="table-row" slot-scope="props">
                        <div>
                            <span>
                                {{ props.formattedRow[props.column.field] }}
                            </span>
                        </div>
                    </template>
                </vue-good-table>
            </material-card>
        </v-flex>
    </v-container>
</template>

<script>
import { pluralize, sum, formatCurrency } from "../utils/helpers.js";
import moment from "moment";

export default {
    data: () => ({
        title: "Chol Hamoed Program Totals",
        totals: [],
        isExporting: false,
        classSummary: [],
        programs: [],
        program: "",
        terms: [],
        regID: "",

        columns: [],
    }),
    watch: {},
    async created() {
        await this.loadPrograms();
        await this.loadTerms();
        await this.loadRegID();
        this.loadData();
    },
    methods: {
        async loadData() {
            if (this.program.startsWith("H-11")) {
                return this.loadH11Data();
            }

            const classSummary = await this.$http.get(
                "api/cholHamoedProgramReports/GetExpensesSummary",
            );

            this.classSummary = classSummary.map((g) => ({
                date: g[0].date,
                expense: sum(g.map((l) => l.expense)),
                children: g.map((sectionGroup) => {
                    sectionGroup.date = sectionGroup.date;
                    sectionGroup.expense = sectionGroup.expense;
                    return sectionGroup;
                }),
            }));

            this.columns = [
                {
                    sortable: false,
                    label: "Date",
                    field: "date",
                    type: "date",
                    dateOutputFormat: "MM/DD/YYYY",
                    hidden: false,
                },
                {
                    sortable: true,
                    label: "Class",
                    field: "section",
                    hidden: false,
                },
                {
                    sortable: true,
                    label: "Expense",
                    field: "expense",
                    formatFn: (value) => formatCurrency(value),
                    type: "number",
                    hidden: false,
                },
            ];
        },
        async loadH11Data() {
            const classSummary = await this.$http.get(
                "api/cholHamoedProgramReports/GetClassSummary?regID=" +
                    this.regID +
                    "&program=" +
                    this.program,
            );

            this.classSummary = classSummary;

            this.columns = [
                {
                    sortable: true,
                    label: "Class",
                    field: "class",
                    hidden: false,
                    tdClass: (row) => {
                        if (row.class == "Total") {
                            return "h11-points-total";
                        }
                    },
                },
                {
                    sortable: true,
                    label: "Points",
                    field: "points",
                    //formatFn: (value) => formatCurrency(value),
                    type: "number",
                    hidden: false,
                    tdClass: (row) => {
                        if (row.class == "Total") {
                            return "h11-points-total";
                        }
                    },
                },
            ];
        },
        async loadTerms() {
            this.terms = await this.$http.get("api/allStudents/getRegTerms");
        },
        async loadRegID() {
            this.regID = await this.$http.get("api/allStudents/getRegID");
        },
        async onProgramChanged(value) {
            this.loadData();
        },
        onTermChanged(value) {
            this.loadData();
        },
        async loadPrograms() {
            this.programs = await this.$http.get(
                "api/cholHamoedProgramReports/getReportPrograms",
            );

            this.program = this.programs.find((p) =>
                p.name.startsWith("H-11"),
            ).name;
        },
    },
};
</script>
<style>
.toggle-button {
    font-size: 15px;
    padding: 5px !important;
}
.toggle-button-group.v-btn-toggle .v-btn.v-btn--active {
    background-color: #dcdfe6;
}
.v-btn__content {
    color: unset;
}
.h11-points-total {
    font-weight: bold;
}
</style>
